import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blockedslotsUnit'
})
export class BlockedslotsUnitPipe implements PipeTransform {

  transform(value, args?, args2?) {
    // ES6 array destructuring
    let val;
    let str;
    let content;
    let title;
    if (args && args.indexOf('All') < 0) {
      args = args.toLowerCase();
      return value.filter(block => {
        if (block.unitNames.indexOf(args) >= 0) {
          return block;
        }
      });
    }
    else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/blockedslots-unit.pipe.ts